module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-17.9d0a0c8e.png";